import * as React from "react"
import {Box} from "@mui/material";

import {navWidth, navWidthMini} from "../@signals";
import {useApp} from "../@hooks";


export default function AppNav({ children, ...props }) {
	const { isMini } = useApp()

	return <Box
		component="nav"
		{...props}
		sx={{
			flexShrink: { lg: 0 },
			width: isMini ? navWidthMini.value : navWidth.value,
			...props?.sx
		}}
	>
		{children}
	</Box>
}